<template>
<div>
  <top-nav></top-nav>
  <div style="display:flex;flex-direction:column;align-items:center">
    <queue></queue>
  </div>
</div>
</template>

<script>
import TopNav from './TopNav.vue'
import Queue from '../../Queue.vue'

export default {
  name: 'OhmQueue',

  components: {
    TopNav,
    Queue
  }
}
</script>

